import { PaymentView } from "@/features/payment-view";
import { createFileRoute } from "@tanstack/react-router";
import { verifyRoles } from "../../../utils/verifyRoles";

export const Route = createFileRoute(
  "/dashboard/payments/$tenantId/$paymentId",
)({
  component: PaymentView,
  beforeLoad: () => verifyRoles(["INIC_ADMIN", "ORG_ADMIN", "ORG_OPERATOR"]),
});
